// src/pages/FundPlanner/components/Portfolios/Main/MaturityReport.jsx
import React from "react";

function formatCurrency(value) {
  if (value == null) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(value);
}

function formatPercent(value, digits = 1) {
  if (value == null) return "—";
  return `${(Number(value) * 100).toFixed(digits)}%`;
}

function InlineBar({ value }) {
  const pct = Math.max(0, Math.min(100, Number(value || 0) * 100));

  return (
    <div className="w-full">
      <div className="h-2 overflow-hidden rounded-full bg-[hsl(var(--muted))]">
        <div
          className="h-full rounded-full bg-[hsl(var(--primary))]"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}

export default function MaturityReport({ buckets }) {
  return (
    <div className="grid gap-6 xl:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
      <div className="rounded-2xl border border-border bg-app p-4">
        <div className="text-sm font-semibold text-app">Maturity Ladder</div>
        <div className="mt-1 text-sm text-muted">
          Based on effective maturity date and market value.
        </div>

        <div className="mt-5 space-y-4">
          {buckets.map((bucket) => (
            <div
              key={bucket.key}
              className="grid items-center gap-3 md:grid-cols-[7rem_minmax(0,1fr)_6rem]"
            >
              <div className="text-sm text-app">{bucket.label}</div>
              <InlineBar value={bucket.percentOfTotal} />
              <div className="text-right text-sm text-muted">
                {formatPercent(bucket.percentOfTotal)}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl border border-border bg-app">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-[hsl(var(--muted)/0.35)]">
              <tr className="text-left">
                <th className="px-4 py-3 font-medium text-app">Tenor</th>
                <th className="px-4 py-3 font-medium text-app text-right">Market Value</th>
                <th className="px-4 py-3 font-medium text-app text-right">% Total</th>
                <th className="px-4 py-3 font-medium text-app text-right">Count</th>
              </tr>
            </thead>
            <tbody>
              {buckets.map((bucket) => (
                <tr key={bucket.key} className="border-t border-border">
                  <td className="px-4 py-3 text-app">{bucket.label}</td>
                  <td className="px-4 py-3 text-right text-app">
                    {formatCurrency(bucket.marketValue)}
                  </td>
                  <td className="px-4 py-3 text-right text-app">
                    {formatPercent(bucket.percentOfTotal)}
                  </td>
                  <td className="px-4 py-3 text-right text-app">{bucket.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
